export const getUpiSettingsFromSettingsResponse = (settingsJson) => {
  const value = settingsJson?.data?.settings?.payment_upi?.value;
  if (!value || typeof value !== 'object') {
    return {
      enabled: false,
      vpa: '',
      payeeName: '',
      merchantCode: null,
      websiteUrl: null,
      notePrefix: 'Order'
    };
  }

  return {
    enabled: Boolean(value.enabled),
    vpa: value.vpa || '',
    payeeName: value.payeeName || '',
    merchantCode: value.merchantCode || null,
    websiteUrl: value.websiteUrl || null,
    notePrefix: value.notePrefix || 'Order'
  };
};

export const fetchUpiSettings = async ({ apiBase = '' } = {}) => {
  const res = await fetch(`${apiBase}/api/settings`);
  const json = await res.json();
  if (!res.ok || !json?.success) {
    throw new Error(json?.message || 'Failed to load payment settings');
  }
  return getUpiSettingsFromSettingsResponse(json);
};

const encodeQuery = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    const s = String(v);
    if (!s) return;
    usp.set(k, s);
  });
  return usp.toString();
};

export const buildUpiPayUrl = ({
  vpa,
  payeeName,
  amount,
  txRef,
  note,
  currency = 'INR',
  merchantCode,
  websiteUrl
}) => {
  const am = typeof amount === 'number' ? amount.toFixed(2) : String(amount || '').trim();

  // Standard UPI scheme: upi://pay
  const qs = encodeQuery({
    pa: vpa,
    pn: payeeName,
    tr: txRef,
    tn: note,
    am,
    cu: currency,
    mc: merchantCode,
    url: websiteUrl
  });

  return `upi://pay?${qs}`;
};
